module.exports = __webpack_public_path__ + "static/media/ivan.928126d9.JPG";